<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import { useCompletionStatusStore } from "%/dynamic-component-editor/stores/completion-status-store";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import { ELEMENT_PANEL_FOLDER } from "%/dynamic-component-editor/constants/element-panel-folder-names";

export default {
  name: "FolderItemCount",
  elementPanelSettings: {
    folder: ELEMENT_PANEL_FOLDER.FOLDERS,
    displayName: "Num Items in My Folder",
    displayIcon: "material-symbols:numbers",
    elementGroup: "storyElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [StoryPageElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    // Counts what is inside the story being viewed, so it only means anything
    // on a folder — a child would otherwise render a bare "0". Kept visible on
    // the canvas so it can still be selected and designed.
    shouldShowText() {
      return this.editMode || this.entity.isFolder;
    },
    value() {
      return String(useCompletionStatusStore().folderCountsFor(this.storyEntityId, this.entity).childNodes ?? "");
    },
  },
};
</script>
